<template>

  <t-report-generate
      v-model="form"
      modal
      sub-validation-tag="sub-checklist-report-photos-work"
      default-pdf
      enable-generate-pdf
      enable-generate-word
      enable-setting
      origin="Teste de Origem"
      help="Somente serão consideradas inspeções e ambientes finalizados. Para configurar as informações do cabeçalho utilize o cadastro de empresas."
      button-title="Relatório"
      :relation-key="form.workId"
      java-report
      title="Relatório de Acompanhamento por Trabalho">

    <template #default>

      <t-input-search select :options="workOptions"
                      required
                      v-model="form.workId"
                      @change="setSubtitleByWork"
                      label="Trabalho"/>


      <t-input select :options="typeChecklistOptions"
               v-model="form.typeChecklistId"
               @change="getResumeTypeChecklistModel"
               placeholder="Todas"
               label="Modelo de Inspeção"/>

      <t-input-search v-model="form.workSequence"
                      enable-range
                      help="Utiliza como filtro o campo 'Sequência dentro do trabalho' contido no cadastro do empreendimento. Deixe em branco para inserir todos"
                      number
                      label="Sequência"/>

      <t-input-search v-model="form.issueDate" placeholder="Todas" date enable-range
                      label="Período Inspeções"/>


        <t-input v-model="form.titleReport" required label="Título do Relatório" small="Título padrão de acordo com o modelo de inspeção"/>
      <t-input v-model="form.subtitleReport" label="Subtítulo do Relatório" small="Subtitulo padrão de acordo com o título do trabalho selecionado"/>


    </template>

    <template #setting>

      <t-input-search required select v-model="form.reportLayout"
                      :options="ReportEvidenceLayoutType.list"
                      label="Layout padrão"/>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.subtitleSequenceEnable" switch>
        Inserir numeração na legenda?
      </b-form-checkbox>

      <t-input label="Começar númeração das fotos por" :disabled="!form.subtitleSequenceEnable"
               v-model="form.subtitleSequenceStart"/>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideHeaderFooter" switch>
        Ocultar todas informações do cabeçalho e rodapé?
      </b-form-checkbox>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideSpotFolderDivision" switch>
        Ocultar informações da Divisão e Pavimento?
      </b-form-checkbox>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideEnvironment" switch>
        Ocultar informações do Ambiente?
      </b-form-checkbox>

      <b-form-checkbox class="mt-2 mb-2" v-show="!form.reportHideSpotFolderDivision" v-model="form.reportBreakPageBySpotFolder" switch>
        Habilitar quebra de página por pavimento?
      </b-form-checkbox>


      <t-input-search required radio v-show="!form.reportHideHeaderFooter" v-model="form.reportHeaderPositionLogo"
                      :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>


      <t-input radio required stacked v-model="form.subtitleFormat"
               :options="ReportSubtitleType.list" label="Formato das legendas"/>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportShowCover" switch>
        Exibir a capa?
      </b-form-checkbox>


    </template>

  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import WorkService from "@/services/modules/place/Work.service";
import ReportEvidenceLayoutType from "@/model/types/modules/checklist/ReportEvidenceLayoutType";
import ReportPositionLogoHeaderType from "@/model/types/modules/checklist/ReportPositionLogoHeaderType";
import ReportSubtitleType from "@/model/types/modules/checklist/ReportSubtitleType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";


export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportPhotoWorkEvidence',
  data() {
    return {
      ReportEvidenceLayoutType,
      ReportPositionLogoHeaderType,
      ReportSubtitleType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        workId: 0,
        enterpriseId: this.enterpriseId,
        typeChecklistId: 0,
        enableAllEnterprises: true,
        titleReport: "Relatório Fotográfico",
        subtitleReport: "",
        workSequence: "",
        issueDate: "",
        reportHideHeaderFooter: false,
        reportHideSpotFolderDivision: false,
        reportBreakPageBySpotFolder: false,
        reportLayout: ReportEvidenceLayoutType.type.BASIC_4_PHOTOS_PORTRAIT,
        reportHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        subtitleFormat: ReportSubtitleType.type.BASIC,
        subtitleSequenceEnable: true,
        subtitleSequenceStart: 1,
        reportShowCover: true,
      },
      typeChecklist: {},
      workOptions: [],
      typeChecklistOptions: [],
    }
  },
  props: {
    enterpriseId: Number,
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await WorkService.selectList().then((list) => {
        this.workOptions = list
      }).catch(error => this.responseError(error))

      await TypeChecklistModelService.selectList().then((list) => {
        this.typeChecklistOptions = list
      }).catch(error => this.responseError(error))

    },

    setSubtitleByWork() {

      setTimeout(() => {

        if (this.form.workId > 0) {
          this.form.subtitleReport = this.workOptions.find(a => a.value === this.form.workId).text
        }

      }, 100)

    },

    async getResumeTypeChecklistModel() {

      setTimeout(async () => {

        if (this.form.typeChecklistId > 0) {
          await TypeChecklistModelService.getResume("id", this.form.typeChecklistId).then(resume => {


            this.form.titleReport = resume.reportEvidenceDefaultTitle

            /*IDEM EM WORK EVIDENCE E CHECKLIST EVIDENCE*/
            this.form.reportLayout = resume.reportEvidenceDefaultLayout
            this.form.reportHeaderPositionLogo = resume.reportEvidenceDefaultHeaderPositionLogo
            this.form.reportHideHeaderFooter = resume.reportEvidenceDefaultHideHeaderFooter
            this.form.reportHideSpotFolderDivision = resume.reportEvidenceDefaultHideSpotFolderDivision
            this.form.reportHideEnvironment = resume.reportEvidenceDefaultHideEnvironment
            this.form.reportBreakPageBySpotFolder = resume.reportEvidenceBreakPageBySpotFolder
            this.form.reportShowCover = resume.reportEvidenceShowCover
            this.form.environmentSort = resume.reportEvidenceDefaultEnvironmentSort
            this.form.subtitleFormat = resume.reportEvidenceDefaultSubtitleFormat
            /*---*/

          })
        }

      }, 100)

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
